import React, { useState, useEffect, useContext } from "react"
import styled from "styled-components"
import * as lookup from "../../../../static/lookup.json"
import { FaCheck } from "@react-icons/all-files/fa/FaCheck"
import { SectionContext } from "../../context/sectionContext"
import { JourneyContext } from "../../context/journeyContext"
import { ConditionContext } from "../../context/conditionContext"
import { PageContext } from "../../context/pageContext"
import { ErrorContext } from "../../context/errorContext"
import { DataLayerEventContext } from "../../context/dataLayerEventContext"
import {
  generateBI,
  fetchAllJourneyData,
  pdfDownload,
  uploadDocument,
  saveApplication,
  fetchApplicationDetails,
  sendEmailBI,
  s3uploadPdfBI,
  whatsAppOptin,
  getTOFpaymentReceipt,
  saveTransactionDetails
} from "../../../services/apiservice"
import {
  getDateInFormat,
  getStateFromCode,
  getAge,
  findCurrentJourneyCode,
  getValueFromLookup,
  findRiderSA,
  findRiderSAPercent,
  getSourceFromChannel,
  DataLayerIntegration,
  transformReceiptToTransaction
} from "../../services/helperFunctions"
import {
  errorToastr,
  successToastr,
  clearToastr,
} from "../../../services/error-handler"
import { wordCapital, lineCapital, applyComma, maskInFormat } from '../../../shared/functions'
const moment = require('moment')
// import * as lookup from "../../../../static/lookup.json"
export default function BIInvest4g(props) {
  let [isactive, setIsActive] = useState(true)
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [pageState, setPageState] = useContext(PageContext)
  const [errorState, setErrorState] = useContext(ErrorContext);
  const [allJourneyData, setAllJourneyData] = useState()
  const [biApiData, setBiApiData] = useState()
  const [fundValue, setFundValue] = useState()
  const [payNowOrLater, setPayNowOrLater] = useState("now")
  const [pdfData, setPdfData] = useState("")
  const [agreeToDeclaration, setAgreeToDeclaration] = useState(true)
  const [proceedWithOption, setProceedWithOption] = useState()
  const [location, setLocation] = useState()
  const [isChecked, setIsChecked] = useState(true)
  const [skipPayment, setSkipPayment] = useState(false);
  console.log(allJourneyData?.productDetails?.planOption)
  const [dataLayerEventState, setDataLayerEventState] = useContext(DataLayerEventContext)

  //container
  const RadioContainer = styled.div`
    width: 100%;
    display: block;
    flex-direction: column;
    margin: 15px 0;
    position: relative;
    box-sizing: border-box;
    font-size: 15px;
    color: #505050;
    float: left;

    & > label {
      margin-left: 8px;
      margin-bottom: 5px;
      color: #505050;
      font-size: 16px;
      background-color: #fff;
      padding: 2px 5px;
      z-index: 999;
      position: relative;
      display: inline-block;
      cursor: default;
      max-width: 100%;
      & > .radio-label {
        text-align: center;
      }
    }

    .card {
      width: 100%;
      border-radius: 1rem;
      padding: 1rem 0;
      border-radius: 15px;
      background-color: #fff;
      position: relative;
      margin: 0px;
      margin-bottom: 0px;
      cursor: pointer;
      height: 9rem;
      margin-top: 0px;
      box-shadow: 0px 0px 20px #ccc;
      transition: all 200ms;

      .amount {
        color: black;
        margin-bottom: 2rem;
        margin-left: 6.5rem;
        border-left: 1px solid #ccc;
        padding-left: 1.5rem;
        height: 3rem;
        font-size: 21px;
      }
      .desc {
        padding: 0.8rem;
        background: #ededed;
        color: black;
        text-align: center;
        padding-right: 34px;
      }
    }

    /*Check tick start  */
    .checked {
      background: #ededed;
      color: #ededed;
      position: absolute;
      left: 2rem;
      top: 1rem;
      height: 2.5rem;
      width: 2.5rem;
      border-radius: 50%;
      padding: 8px;
      & > * {
        font-size: 1.2rem;
      }
    }

    input:checked ~ .card .checked {
      background: #fff;
      color: ${props =>
        props.channel === "A"
          ? "#3e505d"
          : props.channel === "B"
          ? "#a20a3a"
          : props.channel === "C"
          ? "#0ab0ef"
          : "#eb7f25"};
      color: var(--lumiq-card-bg);
    }
    /*Check tick end */

    .icon-container {
      font-size: 3rem;
      padding: 1rem;
      span {
        border-radius: 50%;
        padding: 1rem;

        background: #3e505d;
        .hero-icon {
          padding-top: 8px;
          color: #fff;
        }
      }
    }

    input:checked ~ .card {
      background-color: ${props =>
        props.channel === "A"
          ? "#3e505d"
          : props.channel === "B"
          ? "#a20a3a"
          : props.channel === "C"
          ? "#0ab0ef"
          : "#eb7f25"};
      background-color: var(--lumiq-card-bg);
      color: #fff;
      .icon-container-1 {
        span {
          background: #fff;
          .hero-icon {
            color: #3e505d;
          }
        }
      }

      .amount {
        color: white;
        margin-bottom: 2rem;
        margin-left: 6.5rem;
        border-left: 1px solid #ccc;
        padding-left: 1.5rem;
        height: 3rem;
        font-size: 21px;
      }
      .desc {
        padding: 0.8rem;
        background: #ffffff;
        color:black
        text-align: center;
        padding-right: 34px;
      }
    }

    input:not(:checked) ~ .card {
      /* opacity: 0.5; */
      .amount {
        color: #818181;
      }

      .desc {
        color: #3e505d;
      }
    }
  `
  async function downloadLinkOfPdf(Base64Pdf) {
    // if(!location){
    //   const result = await s3uploadPdfBI({applicationNumber: journeyState.applicationNo,
    //     Base64Pdf: Base64Pdf,
    //   })
    //   setLocation(result.data.location)
    //   window.open(result.data.location,"_self");
    // }else{
    //   window.open(location,"_self");
    // }
    const fileName = `${lookup?.pdfProdutPlanName[journeyState?.journeyIdFromStrapi] ?? ""}_${journeyState.applicationNo}.pdf`
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      var byteCharacters = atob(Base64Pdf)
      var byteNumbers = new Array(byteCharacters.length)
      for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      var byteArray = new Uint8Array(byteNumbers)
      var blob = new Blob([byteArray], { type: "application/pdf" })
      window.navigator.msSaveOrOpenBlob(blob, fileName)
      return
    }
    // For Other Browsers
    const linkSource = "data:application/pdf;base64," + Base64Pdf
    const link = document.createElement("a")
    link.href = linkSource
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    link.remove()

    window.addEventListener(
      "focus",
      function () {
        URL.revokeObjectURL(link.href)
      },
      { once: true }
    )
  }

  const handleOnChange = () => {
    setIsChecked(!isChecked);
  };

  const downloadPdf = async () => {
    let sendEmailPdfData = pdfData
    if (!sendEmailPdfData) {
      if (!biApiData) {
        return
      } else {
        let pdfResult = await pdfDownload({
          applicationNumber: journeyState.applicationNo,
          TID: biApiData?.TransactionId || "",
        })
        setPdfData(pdfResult.data.Base64Pdf)
        sendEmailPdfData = pdfResult.data.Base64Pdf
      }
    }
    downloadLinkOfPdf(sendEmailPdfData)
    let journeyFormatData = props.applicationDataInJourneyFormat()
    DataLayerIntegration(journeyFormatData, "", props.sections?.[props.currentSectionIndex]?.sectionId, "download", journeyState)
  }

  const printPdf = async () => {
    if (pdfData) {
      printPdf1(pdfData)
    } else {
      let pdfResult = await pdfDownload({
        applicationNumber: journeyState.applicationNo,
        TID: biApiData?.TransactionId || "",
      })
      setPdfData(pdfResult.data.Base64Pdf)
      printPdf1(pdfResult?.data?.Base64Pdf)
    }

    function printPdf1(base64Data) {
      const newWindow = window.open("", "", "width=100, height=100")
      if (newWindow) {
        const document = newWindow.document.open()
        document.close()
        newWindow.moveTo(0, 0)
        newWindow.resizeTo(window.screen.width, window.screen.height)
        const contentType = "application/pdf"
        const b64Data = base64Data
        const blob = b64toBlob(b64Data, contentType)
        const blobUrl = URL.createObjectURL(blob)
        document.write(`<iframe id="pdfDocument"
        src="${blobUrl}" 
        width="100%"
        height="100%"
        frameBorder="0" ></iframe>`)
        const docs = document.getElementById("pdfDocument")
        setTimeout(() => {
          docs.contentWindow.print()
        }, 1000)
      }
    }
    function b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || ""
      sliceSize = sliceSize || 512

      var byteCharacters = atob(b64Data)
      var byteArrays = []

      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize)

        var byteNumbers = new Array(slice.length)
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i)
        }

        var byteArray = new Uint8Array(byteNumbers)

        byteArrays.push(byteArray)
      }

      var blob = new Blob(byteArrays, { type: contentType })
      return blob
    }
    let journeyFormatData = props.applicationDataInJourneyFormat()
    DataLayerIntegration(journeyFormatData, "", props.sections?.[props.currentSectionIndex]?.sectionId, "print", journeyState)
  }

  const sendEmail = async (callS3uploadPdf) => {
    if (!biApiData) {
      return
    }
    let payload = {
      journeyId: journeyState.journeyId,
      module: "BIEMAIL",
      applicationNumber: callS3uploadPdf ? journeyState.applicationNo : "",
      TID: biApiData?.TransactionId || "",
    }
    sendEmailBI(payload).then(res => {
      console.log(res, "emailRes")
      if (res?.status) {
        successToastr(res.message)
      } else {
        errorToastr(res.message)
      }
    })
    let journeyFormatData = props.applicationDataInJourneyFormat()
    DataLayerIntegration(journeyFormatData, "", props.sections?.[props.currentSectionIndex]?.sectionId, "email", journeyState)
  }


  //async function to make API call
  const getData = async () => {
    console.log("journeyState",journeyState.journeyId);
    let applicationDetailsPayload = {
      _id: journeyState.journeyId,
    }
    let applicationResult = await fetchApplicationDetails(
      applicationDetailsPayload
    )

    let payload = {
      journeyId: journeyState.journeyId,
      allRowData: true,
    }
    let journeyResult = await fetchAllJourneyData(payload)
    console.log("journeyresult",journeyResult);
    if (journeyResult?.lifeAssuredDetails?.proceedWith) {
      setProceedWithOption(journeyResult?.lifeAssuredDetails?.proceedWith)
    }
    if(journeyResult?.journeyType?.toLowerCase() === "canarapos"){
      setPayNowOrLater("later")
    }
    generateBI(payload).then(async data => {
      console.log(journeyResult, data, "vjhdvhhs")
      setAllJourneyData(journeyResult)
      if(journeyResult?.productDetails?.nVestFundDetails){
        let fund = journeyResult?.productDetails?.nVestFundDetails
        console.log(fund)
        let finalData = {}
        Object.keys(fund).forEach(path => {
          let fundName
          let allocationPercentage
          fundName = fund[path].fundId
          allocationPercentage = fund[path].fundPercent
          console.log(fundName)
          finalData[fundName] = allocationPercentage
        })
        console.log(finalData.ELEF)
        setFundValue(finalData)
      }
      setJourneyState(prev => {
        return {
          ...prev,
          premium: Math.round(JSON.parse(data?.data?.BIJson)?.[0].MODAL_PREM_DISP) || 0,
          journeyData: applicationResult.applicationData,
        }
      })
      let pdfResult = await pdfDownload({
        applicationNumber: journeyState.applicationNo,
        TID: data.data.TransactionId || "",
      })
      setPdfData(pdfResult.data.Base64Pdf)
      setBiApiData(data.data)

      getTOFpaymentReceipt(journeyState.applicationNo)
      .then(res => {
        const receipts = res.data || [];
        const validReceipts = receipts.filter(receipt => lookup.validReceiptStatus[0].hasOwnProperty(receipt.receiptStatus));
        let sum = 0;
        validReceipts.forEach(receipt => {
          sum += parseInt(receipt.amount);
        });
        if (sum >= (Math.round(JSON.parse(data.data.BIJson)?.[0].MODAL_PREM_DISP))) {
          setSkipPayment(true);
        }
        setJourneyState(prev => ({
          ...prev,
          receipts: validReceipts 
        }));
      })
      .catch(err => console.info(err));

    })
    .catch(err => {
      console.log("error in save application of save application and call BI function")
    })
  }

  const handleEnterPayoutOption = (event, value) => {
    console.log(event.key);
    if (event.key == 'Enter') {
      handlePayOption({ target: { value: value } })
    }

  }

  //Use Effects
  useEffect(async () => {
    console.log("getdata callaed");
    await getData();
    console.log("bidattttaaaa",biApiData);
  }, [])

  // useEffect(() => {
  //   storePdfData()
  // }, [biApiData])

  //Page Functions
  const handlePayOption = ({ target }) => {
    console.log(target.value, "value in BI");
    if (target.value === "now") {
      setPayNowOrLater("now")
      let journeyFormatData = props.applicationDataInJourneyFormat()
      DataLayerIntegration(journeyFormatData, "", props.sections?.[props.currentSectionIndex]?.sectionId, "payNowCheck", journeyState)
    } else if (target.value === "later") {
      setPayNowOrLater("later")
      let journeyFormatData = props.applicationDataInJourneyFormat()
      DataLayerIntegration(journeyFormatData, "", props.sections?.[props.currentSectionIndex]?.sectionId, "payLaterCheck", journeyState)
    }
  }

  const handlePrevious = () => {
    let sectionIndex = props.currentSectionIndex
    let pageIndex = props.currentPageIndex
    let sectionIndexToEmpty = sectionIndex - 1
    let pageSectionIndexToEmpty =`${pageIndex}${sectionIndexToEmpty}`
    let eventCalledToFillObject = {}
    let eventCalledToFill = Object.keys(
      dataLayerEventState?.eventCalled
    ).filter(element => {
      return element !== pageSectionIndexToEmpty
    })
    console.log(eventCalledToFill);
    for(let i=0; i<eventCalledToFill.length;i++){
      eventCalledToFillObject[eventCalledToFill[i]] = true
    }
    console.log(eventCalledToFillObject);
    setDataLayerEventState(prev=>{
      return{
        eventCalled:{
          ...eventCalledToFillObject
        }
      }
    })
    console.log(dataLayerEventState);
    let journeyFormatData = props.applicationDataInJourneyFormat()
    DataLayerIntegration(journeyFormatData, "previous", props.sections?.[props.currentSectionIndex]?.sectionId, "", journeyState)
    if (proceedWithOption === "manually") {
      props.setCurrentSectionIndex(prev => prev - 1) // this moves to previous section on same page
      setJourneyState(prev => {
        return {
          ...prev,
          lastPage: props.currentPageIndex,
          lastSection: props.currentSectionIndex,
          premium: biApiData && Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_DISP),
          lastPageCode: props.pageId,
          lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
          journeyCode: findCurrentJourneyCode(
            props.pageId,
            props.sections[props.currentSectionIndex].sectionId
          ),
        }
      })
    }
  }

  // code of tab enter
  const handleEnterPrevious = (event) => {
    if (event?.key == 'Enter') {
      handlePrevious();
    }
  }
  // code of tab enter
  const handleEnterDownload = (event) => {
    if (event?.key == 'Enter') {
      downloadPdf();
    }
  }
  // code of tab enter
  const handleEnterPrint = (event) => {
    if (event?.key == 'Enter') {
      printPdf();
    }
  }
  // code of tab enter
  const handleEnterEmail = (event) => {
    if (event?.key == 'Enter') {
      sendEmail(true);
    }
  }
  // code of tab enter
  const handleEnterRecalculate = (event) => {
    if (event?.key == 'Enter') {
      handleReCalculate();
    }
  }

  const handleProceed = async ev => {
    ev.preventDefault()
    if (!isChecked) {
      return;
    }
    console.log("tessttttttxxxxxxxxxxx",props);

    // downloadLinkOfPdf(pdfData);
    sendEmail(true);
    // const result = await s3uploadPdfBI({
    //   applicationNumber: journeyState.applicationNo,
    //   Base64Pdf: pdfData,
    // })
    // const b64Data = pdfData
    // const blob = b64toBlob(b64Data, "application/pdf")
    // let formData = new FormData()
    // if (blob) {
    //   const file = blob
    //   formData.append("doc", file)
    //   formData.append("sub", false)
    //   formData.append("docPurpose", "BIPDF")
    //   try {
    //     const res = await uploadDocument(formData, journeyState.applicationNo)
    //     console.log({ res })
    //   } catch (error) {
    //     console.log(error)
    //   }
    // }
    // function b64toBlob(b64Data, contentType, sliceSize) {
    //   contentType = contentType || ""
    //   sliceSize = sliceSize || 512

    //   var byteCharacters = atob(b64Data)
    //   var byteArrays = []

    //   for (
    //     var offset = 0;
    //     offset < byteCharacters.length;
    //     offset += sliceSize
    //   ) {
    //     var slice = byteCharacters.slice(offset, offset + sliceSize)

    //     var byteNumbers = new Array(slice.length)
    //     for (var i = 0; i < slice.length; i++) {
    //       byteNumbers[i] = slice.charCodeAt(i)
    //     }

    //     var byteArray = new Uint8Array(byteNumbers)

    //     byteArrays.push(byteArray)
    //   }

    //   var blob = new Blob(byteArrays, { type: contentType })
    //   return blob
    // }

    if (payNowOrLater === "now") {
      let journeyFormatData = props.applicationDataInJourneyFormat()
      DataLayerIntegration(journeyFormatData, "", props.sections?.[props.currentSectionIndex]?.sectionId, "payNow", journeyState)
      console.log("tesstttttt",journeyState.journeySteps.pages);
      let temp = journeyState.journeySteps
      if(["fillProposalForm", "PageFlexiEdgeFillProposalForm"].includes(temp.pages[2].pageId)){
        let element = temp.pages[3]
        temp.pages.splice(3, 1)
        temp.pages.splice(2, 0, element)
      }
      setJourneyState(prev => {
        return {
          ...prev,
          journeySteps: temp,
          lastPage: props.currentPageIndex,
          lastSection: props.currentSectionIndex,
          premium: biApiData && Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_DISP),
          lastPageCode: props.pageId,
          lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
          paymentStep: "N",
          journeyCode: findCurrentJourneyCode(
            props.pageId,
            props.sections[props.currentSectionIndex].sectionId
          ),
        }
      })
    console.log("journeystateeee",journeyState);

    }else{
      let journeyFormatData = props.applicationDataInJourneyFormat()
      DataLayerIntegration(journeyFormatData, "", props.sections?.[props.currentSectionIndex]?.sectionId, "payLater", journeyState)
      console.log("tesstttttt",journeyState.journeySteps.pages);

      let temp = journeyState.journeySteps.pages
      if(["makePayment"].includes(temp[2].pageId)){
        let element = temp[3]
        temp.splice(3, 1)
        temp.splice(2, 0, element)
      }
      setJourneyState(prev => {
        return {
          ...prev,
          journeySteps: {
            pages: temp,
          },
          lastPage: props.currentPageIndex,
          lastSection: props.currentSectionIndex,
          premium: biApiData && Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_DISP),
          lastPageCode: props.pageId,
          lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
          paymentStep: "L",
          journeyCode: findCurrentJourneyCode(
            props.pageId,
            props.sections[props.currentSectionIndex].sectionId
          ),
        }
      })
      setDataLayerEventState(prev => {
        return({
          ...prev,
          eventCalled: {
            '23':true
          }
        })
      })
    }
    console.log("journeystateee222222222222222e",journeyState);
    setSectionState(prev => {
      // making section data empty to load new sectionData
      return {
        ...prev,
        sectionId: null,
        sectionFirstPass: null,
        sectionData: {},
      }
    })
    let sendPayload = {
      applicationData: journeyState.journeyData,
      journeyData: {
        _id: journeyState.journeyId,
        lastPage: props.currentPageIndex,
        lastSection: props.currentSectionIndex,
        applicationNo: journeyState.applicationNo,
        illustrationNumber: journeyState.illustrationNumber,
        proposalEntryId: journeyState.proposalEntryId,
        lastPageCode: props.pageId,
        paymentStep: payNowOrLater === "now" ? "N" : "L",
        lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
        premium: biApiData && Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_DISP),
        planOption: journeyState.planOption,
        canaraPosCaseType: allJourneyData?.journeyType?.toLowerCase() === "canarapos" ? "sendCaseToCustomer" : null
        },
        posDashboardListingData:{
          canaraPosCaseType: "sendCaseToCustomer"
        }
      // base64Data: pdfData,
    }
    saveApplication(sendPayload).then(res => {
      console.log(res, "application response")
      props.setCurrentPageIndex(prev => prev + 1)
      setErrorState({})
      setErrorState({})
      setErrorState({})
      setErrorState({})
      props.setCurrentSectionIndex(0) 
      setSectionState(prev => {
        // making section data empty to load new sectionData
        return {
          ...prev,
          sectionId: null,
          sectionFirstPass: null,
          sectionData: {},
        }
      })
    }).catch(err => {
      console.log(err, "err in saveApplication benefit-illustration")
    })
  }

  const handleProceedSkipPayment = (e) => {
    e.preventDefault();
  
    const temp = journeyState.journeySteps;
    console.log(temp);
    let makePaymentPageIndex = temp.pages.findIndex(page => page.pageId === "makePayment");
    let fillProposalFormPageIndex = temp.pages.findIndex(page => page.pageId === "PageFlexiEdgeFillProposalForm");
    let makePaymentPageSections = temp.pages[makePaymentPageIndex].sections;
    makePaymentPageSections = makePaymentPageSections.filter(section => section.sectionId === "eNach-physicalMandate");
    temp.pages[makePaymentPageIndex].sections = makePaymentPageSections;
    let tempPage = temp.pages[makePaymentPageIndex];
    temp.pages[makePaymentPageIndex] = temp.pages[fillProposalFormPageIndex];
    temp.pages[fillProposalFormPageIndex] = tempPage;
    setJourneyState(prev => {
      return {
        ...prev,
        journeySteps: temp
      }
    });
  
    let sendPayload = {
      applicationData: journeyState.journeyData,
      skipPayment:'Y',
      journeyData: {
        _id: journeyState.journeyId,
        lastPage: props.currentPageIndex + 1,
        lastSection: 0,
        applicationNo: journeyState.applicationNo,
        illustrationNumber: journeyState.illustrationNumber,
        proposalEntryId: journeyState.proposalEntryId,
        premium: Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_DISP) || 0,
        lastPageCode: props.pageId,
        paymentStep: "N",
        lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
        planOption: journeyState.planOption,
        canaraPosCaseType: allJourneyData?.journeyType?.toLowerCase() === "canarapos" ? "sendCaseToCustomer" : null
      },
      // base64Data: pdfData,
    }
  
    saveApplication(sendPayload).then(async res => {
      console.log(res, "application response");
      props.setCurrentPageIndex(prev => prev + 1);
      setErrorState({});
      props.setCurrentSectionIndex(0); // this moves to first section of next page
  
      // Save transaction details if skipPayment is true
      if (skipPayment) {
        const validReceipts = journeyState.receipts || [];
        const transactions = validReceipts.map(receipt => transformReceiptToTransaction(receipt, journeyState));
  
        const transactionPayload = {
          journeyId: journeyState.journeyId,
          applicationNumber: journeyState.applicationNo,
          status: 'Success',
          skipPayment: 'Y',
          transactions: transactions
        };

        let saveResp = await saveTransactionDetails(transactionPayload);

      }
      

    }).catch(err => {
      console.log(err, "err in saveApplication benefit-illustration");
    });
  }

  const handleReCalculate = () => {
    setDataLayerEventState(prev => {
      return({
        ...prev,
        eventCalled: {
        }
      })
    })
    let journeyFormatData = props.applicationDataInJourneyFormat()
    DataLayerIntegration(journeyFormatData, "", props.sections?.[props.currentSectionIndex]?.sectionId, "reCalculate", journeyState)
      props.setCurrentPageIndex(0)
      props.setCurrentSectionIndex(0)
      const tempPage = journeyState.journeyData[0]
      setPageState(prev => {
        return {
          ...prev,
          pageId: tempPage.pageId,
          pageData: tempPage.pageData,
        }
      })
      const tempState = journeyState.journeyData[0].pageData[0]
      setSectionState(prev => {
        return {
          ...prev,
          sectionId: tempState.sectionId,
          sectionData: tempState.sectionData,
        }
      })
  }  

  const handleSendLinkToSales = (ev) => {
    ev.preventDefault()
    if (!isChecked) {
      return;
    }
    sendEmail(true);
    console.log("tesstttttt",journeyState.journeySteps.pages);
    let temp = journeyState.journeySteps

    temp.pages = temp.pages.filter(page => page.pageId !== "PageFlexiEdgeFillProposalForm" && page.pageId !== "makePayment" && page.pageId !== "PageFlexiEdgeUploadDocuments")
    temp.pages.push(...lookup.sendLinktosales)
    if(allJourneyData?.productDetails?.premiumFrequency === "SG"){
      temp.pages = temp.pages.filter(page => page.pageId !== "makePayment")
    }
    console.log(temp.pages)

    setJourneyState(prev => {
      return {
        ...prev,
        journeySteps: temp,
        lastPage: props.currentPageIndex,
        lastSection: props.currentSectionIndex,
        premium: biApiData && Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_TAX),
        lastPageCode: props.pageId,
        lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
        paymentStep: "L",
        journeyCode: findCurrentJourneyCode(
          props.pageId,
          props.sections[props.currentSectionIndex].sectionId
        ),
        canaraPosCaseType: "sendLinktosales"
      }
    })
  console.log("journeystateeee",journeyState);
  setSectionState(prev => {
    // making section data empty to load new sectionData
    return {
      ...prev,
      sectionId: null,
      sectionFirstPass: null,
      sectionData: {},
    }
  })
  // let optInPayload = {
  //   "mobileNo": allJourneyData.salesAgentDetails.mobileNo
  // }
  // let whatsAppOptres = whatsAppOptin(optInPayload)
  let sendPayload = {
    applicationData: journeyState.journeyData,
    journeyData: {
      _id: journeyState.journeyId,
      lastPage: props.currentPageIndex,
      lastSection: props.currentSectionIndex,
      applicationNo: journeyState.applicationNo,
      illustrationNumber: journeyState.illustrationNumber,
      proposalEntryId: journeyState.proposalEntryId,
      lastPageCode: props.pageId,
      paymentStep: payNowOrLater === "now" ? "N" : "L",
      lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
      premium: biApiData && Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_TAX),
      planOption: journeyState.planOption,
      canaraPosCaseType: "sendLinktosales"
    },
    posDashboardListingData:{
      canaraPosCaseType: "sendLinktosales"
    }
  }
  saveApplication(sendPayload).then(res => {
    console.log(res, "application response")
    successToastr('Application will be visible on sales Dashboard after SCR Declaration')
    props.setCurrentPageIndex(prev => prev + 1)
      setErrorState({})
      setErrorState({})
      setErrorState({})
      setErrorState({})
      props.setCurrentSectionIndex(0) 
      setSectionState(prev => {
        // making section data empty to load new sectionData
        return {
          ...prev,
          sectionId: null,
          sectionFirstPass: null,
          sectionData: {},
        }
      })
  }).catch(err => {
    console.log(err, "err in saveApplication benefit-illustration")
  })
  }


  let personalDetails = [
    {
      q1: "Date of Birth",
      ans1: allJourneyData?.lifeAssuredDetails?.dob ?  maskInFormat(allJourneyData?.lifeAssuredDetails?.dob * 1000) : "NA",
      q2: "Age",
      ans2: getAge(allJourneyData?.lifeAssuredDetails?.dob),
    },
    {
      q1: "Proposer Name",
      ans1:allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? (wordCapital(allJourneyData?.proposerDetails?.firstName ?? '') + " " + wordCapital(allJourneyData?.proposerDetails?.middleName ?? '') + " " + wordCapital(allJourneyData?.proposerDetails?.lastName)) :wordCapital(allJourneyData?.lifeAssuredDetails?.fullName ?? ''),
      q2: "Gender",
      ans2: getValueFromLookup("gender",allJourneyData?.lifeAssuredDetails?.gender) || "NA",
    },
    {
      q1: "Date of Illustration",
      ans1:  allJourneyData?.basicDetails?.applicationNoGenerationTime ? moment.unix(allJourneyData?.basicDetails?.applicationNoGenerationTime).utcOffset("+05:30").format("DD/MMM/YYYY") : "NA" ,
      q2: "",
      ans2: "",
    },
  ]
  let planDetails = [
    {
      q1: "UIN",
      ans1: "136L064V03",
      q2: "Premium Payment Mode",
      ans2: `${lineCapital(getValueFromLookup(
        "premiumFrequency",
        allJourneyData?.productDetails?.premiumFrequency
      ) ?? '') || "NA"}`,
    },
    {
      q1: "Name of the Plan",
      ans1: "Canara HSBC Life Insurance Invest 4G Plan",
      q2: "Annualised Premium",
      ans2: `₹${biApiData ? applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[0].ANN_PREM)) : "NA"}`
    },
    {
      q1: "Policy Term",
      ans1: allJourneyData?.productDetails?.policyTerm || "NA",
      q2: "Goods & Services Tax & applicable cess (es)/ levy, if any",
      ans2: "18%",
    },
    {
      q1: "Plan Benefit-Option",
      ans1: allJourneyData?.productDetails?.premiumPaymentTerm === "ULIGF1" || allJourneyData?.productDetails?.premiumPaymentTerm === "ULIGF4" ? "Life option" : allJourneyData?.productDetails?.premiumPaymentTerm === "ULIGF2" ? "Century option" : "Care option",
      q2: "Target Fund for Systematic Transfer Option",
      ans2: allJourneyData?.productDetails?.sysTransferOption === "Y" ? lineCapital(getValueFromLookup(
        "StoTargetFunds",
        allJourneyData?.productDetails?.chooseTargetStoFund
      ) ?? '') || "NA" : "NA",
    },
    {
      q1: "Premium Payment Term",
      ans1: allJourneyData?.productDetails?.premiumPaymentTerm,
      q2: "Safety Switch Option",
      ans2: lineCapital(getValueFromLookup(
        "yesNo",
        allJourneyData?.productDetails?.safetySwitchOption
      ) ?? '') || "NA",
    },
    {
      q1: "Amount of Installment Premium",
      ans1:  `${biApiData ? JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_DISP : ""}`,
      q2: "",
      ans2: "",
    },
  ]
  let fundAllocation = [
    {
      fundName1: "Emerging Leaders Equity Fund",
      sfin1: "Emerging Leaders Equity Fund",
      allocation1: `${fundValue ? fundValue.ELEF: `0`}%`,
      fundName2: "Balanced Plus Fund",
      sfin2: "ULIF01013/09/10BLNCDPLFND136",
      allocation2:  `${fundValue ? fundValue.BLF3: `0`}%`,
    },
    {
      fundName1: "India Multi-Cap Equity Fund",
      sfin1: "ULIF01816/08/16IMCAPEQFND136",
      allocation1: `${fundValue ? fundValue.IMEF: `0`}%`,
      fundName2: "Debt Fund",
      sfin2: "ULIF00409/07/08INDEBTFUND136	",
      allocation2:  `${fundValue ? fundValue.BDF1: `0`}%`,
    },
    {
      fundName1: "Equity II Fund",
      sfin1: "ULIF00607/01/10EQUTYIIFND136",
      allocation1:  `${fundValue ? fundValue.PEF2: `0`}%`,
      fundName2: "Liquid Fund",
      sfin2: "ULIF00514/07/08LIQUIDFUND136",
      allocation2:  `${fundValue ? fundValue.CSF1: `0`}%`,
    },
    {
      fundName1: "Growth Plus Fund",
      sfin1: "ULIF00514/07/08LIQUIDFUND136",
      allocation1:  `${fundValue ? fundValue.GWF3: `0`}%`,
      fundName2: "Large Cap Advantage Fund",
      sfin2: "ULIF02109/06/20LARCPADFND136",
      allocation2:  `${fundValue ? fundValue.LCAF: `0`}%`,
    },
  ]
  let coverDetails = [
    {
      q1: "Sum Assured",
      ans1:applyComma(allJourneyData?.productDetails?.sumAssured),
      q2: "Fund Allocation",
      ans2:  `@ 4% ${applyComma(journeyState.invest4GFundBiKeys?.invest4GFundValue4Perc)}`
    },
    {
      q1: "",
      ans1:"",
      q2: "Fund Allocation",
      ans2: `@ 8% ${applyComma(journeyState.invest4GFundBiKeys?.invest4GFundValue8Perc)}`
    },
  ]

  return (
    <>
      <style>
        {`

          .option-buit-design-new-new-design::after{
            height: 2rem
          }
          .shadow-box-card{
            background-color: #fff;
            box-shadow: 0px 0px 10px #ccc;
            border-radius: 10px;
            padding: 0px 0px;
            float: left;
            width: 100%;
            margin-bottom: 30px;
            height: 172px;
          }
          .option-buit-design-new-structure-sec1 .checkmark, .option-buit-design-new-structure-sec2 .checkmark, .option-buit-design-new-structure-sec3 .checkmark, .option-buit-design-new-structure-sec4 .checkmark {
            background-color: #ededed;
            left: 0px;
            top: 0px;
          }
          radio-line{
            width: 100%;
            height: 100%
          }
          .customradio{
            padding: 22px 0px
          }
          .customradio .checkmark {
            top: 22px !important;
          }
          .by-pay{
            bottom: 8px
          }
          resent-bi-center{
            position: relative;
          }
          .eky-resend {
            margin: auto;
            right: 25px;
            position: relative;
            left: 4px
          }
          .custom-otp{
            margin: auto
          }
          .table-design .table-bg .border-right td:nth-child(2){
            border-right:1px solid;
          }
          .table-design .table-bg .border-right-fund td:nth-child(3){
            border-right:1px solid;
          }
          .notesTable td{
            border:1px solid black;
            text-align: center;
          }
          .notesTable th{
            border:1px solid black;
            text-align: center;
          }
         
        `}
      </style>
      {allJourneyData && biApiData && (<div className="container">
        {/*left-side*/}
        <form
          id="declaration-form"
          name="declaration-form"
          action
          method="post"
          autoComplete="off"
          noValidate="novalidate"
        >
          <div className="iselect-padding mt-20">
            <div className="iselect-box-design mb">
              <div className="heading-design">
                <div className="iselect-padding left-side-head">
                  <h1 className="iselect-heading">Benefit Illustration</h1>
                  <span className="subhead">
                    Canara HSBC Life Insurance Invest 4G Plan &nbsp; | &nbsp; UIN:
                    136L064V03{" "}
                  </span>{" "}
                </div>
                <div className="app-quatation mt hidden-desktop-screen">
                  <div className="application-design-number">
                    Application Number: {journeyState.applicationNo}
                  </div>
                </div>
              </div>
              <div className="bi-summary">
                <div className="auther-description mt-20">
                  <h3>
                  Dear{" "}
                  {allJourneyData?.journeyType == "CanaraPos" ?
                      <b>
                        { allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? allJourneyData?.proposerDetails?.title === "MR" ? 'Mr. ' :  allJourneyData?.proposerDetails?.title === "MS" ?  'Ms. ' : allJourneyData?.proposerDetails?.title === "MRS" ?  'Mrs. ' : ""
                          : (allJourneyData?.lifeAssuredDetails?.title === "MR" ? 'Mr. ' :  allJourneyData?.lifeAssuredDetails?.title === "MS" ?  'Ms. ' : allJourneyData?.lifeAssuredDetails?.title === "MRS" ?  'Mrs. ': ``)
                        }
                        {allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? (wordCapital(allJourneyData?.proposerDetails?.firstName ?? '') + " " + wordCapital(allJourneyData?.proposerDetails?.middleName ?? '') + " " + wordCapital(allJourneyData?.proposerDetails?.lastName)) :wordCapital(allJourneyData?.lifeAssuredDetails?.fullName ?? '')}
                      </b>
                      :
                      <b>
                        { allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? allJourneyData?.proposerDetails?.gender.toUpperCase() == "M" || allJourneyData?.proposerDetails?.gender.toUpperCase() == "T" ? `Mr. ` : `Ms. `
                          : (allJourneyData?.lifeAssuredDetails?.gender.toUpperCase() == "M" || allJourneyData?.lifeAssuredDetails?.gender.toUpperCase() == "T" ? `Mr. ` : `Ms. `)
                        }
                        {allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? (wordCapital(allJourneyData?.proposerDetails?.firstName ?? '') + " " + wordCapital(allJourneyData?.proposerDetails?.middleName ?? '') + " " + wordCapital(allJourneyData?.proposerDetails?.lastName)) :wordCapital(allJourneyData?.lifeAssuredDetails?.fullName ?? '')}
                      </b>
                      }{" "}
                  </h3>
                  <p className="benefit-title">
                    Thank you for showing interest in our Canara HSBC Life
                    Insurance Invest 4G Plan. Based on the details provided by
                    you, and reproduced below, the illustration customised to
                    your requirements is appended.
                  </p>
                  <p className="benefit-title">
                    Please note that this illustration is indicative and the
                    actual values may vary depending on performance of the
                    non-participating fund managed by the Company.
                  </p>
                </div>
              </div>
              <div className="Bi-design-structure-table mt-50 iselect-mg-bottom">
                <div className="col-md-12">
                  <div className="table-responsive table-design laesf">
                    <h2 className="headline-table">
                      Personal Details of Life to be Assured
                    </h2>
                    <div className="table-bg">
                      <table className="table border-right">
                        <tbody>
                          {personalDetails.map((elem, index) => {
                            return (
                              <tr
                                className={`table-color${
                                  index % 2 == 0 ? "-grey" : ""
                                }`}
                              >
                                <td width="33%">{elem.q1}</td>
                                <td
                                  width="17%"
                                  align="right"
                                  className="rd-tatav"
                                  style={{borderRight:"1px solid #black"}}
                                >
                                  {elem.ans1}
                                </td>
                                <td width="26%" align="left" >
                                  {elem.q2}
                                </td>
                                <td width="24%" align="right">
                                  {elem.ans2}
                                </td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="clearfix" />
                <div className="col-md-12">
                  <div className="table-responsive table-design laesf">
                    <h2 className="headline-table">Plan Details</h2>
                    <div className="table-bg">
                      <table className="table border-right">
                        <tbody>
                          {planDetails.map((elem, index) => {
                            return (
                              <tr
                                className={`table-color${
                                  index % 2 == 0 ? "-grey" : ""
                                }`}
                              >
                                <td width="33%">{elem.q1}</td>
                                <td
                                  width="17%"
                                  align="right"
                                  className="rd-tatav"
                                >
                                  {elem.ans1}
                                </td>
                                <td width="26%" align="left">
                                  {elem.q2}
                                </td>
                                <td width="24%" align="right">
                                  {elem.ans2}
                                </td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="clearfix" />
                <div className="col-md-12">
                  <div className="table-responsive table-design laesf">
                    <h2 className="headline-table">Fund Allocation</h2>
                    <div className="table-bg">
                      <table className="table border-right-fund">
                        <thead className="headline-table" style={{borderTop:"1px solid"}}>
                          <th style={{float:"left",paddingLeft:"10px"}}>Fund Name</th>
                          <th>SFIN</th>
                          <th>Allocation</th>
                          <th style={{float:"left",paddingLeft:"10px"}}>Fund Name</th>
                          <th>SFIN</th>
                          <th>Allocation</th>
                        </thead>
                        <tbody>
                          {fundAllocation.map((elem, index) => {
                            return (
                              <tr
                                className={`table-color${
                                  index % 2 == 0 ? "-grey" : ""
                                }`}
                              >
                                <td width="">{elem.fundName1}</td>
                                <td width="" className="rd-tatav">
                                  {elem.sfin1}
                                </td>
                                <td width="" align="left">
                                  {elem.allocation1}
                                </td>
                                <td width="">{elem.fundName2}</td>
                                <td width="">{elem.sfin2}</td>
                                <td width="">{elem.allocation2}</td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="clearfix" />
                <div className="col-md-12">
                  <div className="table-responsive table-design laesf">
                    <h2 className="headline-table">Cover Details (₹)</h2>
                    <div className="table-bg">
                      <table className="table border-right">
                        <tbody>
                          {coverDetails.map((elem, index) => {
                            return (
                              <tr
                                className={`table-color${
                                  index % 2 == 0 ? "-grey" : ""
                                }`}
                              >
                                <td width="33%">{elem.q1}</td>
                                <td
                                  width="17%"
                                  align="right"
                                  className="rd-tatav"
                                >
                                  {elem.ans1}
                                </td>
                                <td width="26%" align="left">
                                  {elem.q2}
                                </td>
                                <td width="24%" align="right">
                                  {elem.ans2}
                                </td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div className="clearfix" />
              <div className="clearfix" />
              <div className="transactionDetailsWrap">
                <div className="detailContentWrap">
                  <div className="row">
                    <div className="buttonWrap">
                      <div
                        className="button submit-btn"
                        aria-hidden="true"
                        style={{ cursor: "pointer" }}
                        tabIndex="0"
                        onKeyPress={(e) => handleEnterDownload(e)}
                        onClick={downloadPdf}
                      >
                        <a> Download</a>
                      </div>
                      <div
                        className="button submit-btn"
                        aria-hidden="true"
                        style={{ cursor: "pointer" }}
                        tabIndex='0'
                        onKeyPress={(e) => handleEnterPrint(e)}
                        onClick={printPdf}
                      >
                        <a> Print</a>
                      </div>
                      <div
                        className="button submit-btn"
                        aria-hidden="true"
                        style={{ cursor: "pointer" }}
                        tabIndex="0"
                        onKeyPress={(e) => handleEnterEmail(e)}
                        onClick={() => {sendEmail(true)}}
                      >
                        <a> Email</a>
                      </div>
                      <div
                        className="button submit-btn"
                        aria-hidden="true"
                        style={{
                          cursor: "default",
                        }}
                        tabIndex="0"
                        disabled={
                          proceedWithOption === "manually" ? false : true
                        }
                        onKeyPress={(e) => handleEnterRecalculate(e)}
                        onClick={handleReCalculate}
                      >
                        <a>Re-Calculate</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="clearfix" />
              <div className="option-buit-design-new-structure Bi-page-pay-structure mt-30">
                <div className="col-md-12">
                  <div className="option-buit-design-new-structure-box">
                  {allJourneyData?.journeyType !== "CanaraPos" && !skipPayment && (
                          <div className="option-buit-design-new-structure-selected">
                            <div className="row">
                              <div className="col-lg-6 col-md-12 col-xs-12 ">
                                <RadioContainer>
                                  <div
                                    style={{ borderRadius: "15px" }}
                                    className="provider"
                                    tabIndex="0"
                                  >
                                    <label className="width">
                                      <input
                                        type="radio"
                                        name="pay"
                                        value="now"
                                        hidden
                                        onChange={handlePayOption}
                                        checked={
                                          payNowOrLater == "now" ? true : false
                                        }
                                      />
                                      <div className="card">
                                        <div className="checked">
                                          <svg
                                            stroke="currentColor"
                                            fill="currentColor"
                                            stroke-width="0"
                                            viewBox="0 0 512 512"
                                            height="1em"
                                            width="1em"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path>
                                          </svg>
                                        </div>
                                        <div className="amount">
                                          <span>
                                            Pay{" "}
                                            {biApiData
                                              ? `₹ ${applyComma(
                                                  Math.round(
                                                    JSON.parse(
                                                      biApiData.BIJson
                                                    )?.[0].MODAL_PREM_DISP
                                                  )
                                                )}`
                                              : "NA"}{" "}
                                            Now!
                                          </span>
                                        </div>
                                        <div className="desc">
                                          <span>
                                            Pay your{" "}
                                            {lineCapital(
                                              getValueFromLookup(
                                                "biFrequencyLabel",
                                                allJourneyData?.productDetails
                                                  ?.premiumFrequency
                                              ) ?? ""
                                            ) || "NA"}{" "}
                                            Premium{" "}
                                            {biApiData
                                              ? `₹ ${applyComma(
                                                  Math.round(
                                                    JSON.parse(
                                                      biApiData.BIJson
                                                    )?.[0].MODAL_PREM_DISP
                                                  )
                                                )}`
                                              : "NA"}{" "}
                                            now and proceed.
                                          </span>
                                        </div>
                                      </div>
                                    </label>
                                  </div>
                                </RadioContainer>
                              </div>

                              <div className="col-lg-6 col-md-12 col-xs-12 ">
                                <RadioContainer>
                                  <div
                                    style={{ borderRadius: "15px" }}
                                    className="provider"
                                    tabIndex="0"
                                  >
                                    <label className="width">
                                      <input
                                        type="radio"
                                        name="pay"
                                        value="later"
                                        hidden
                                        onChange={handlePayOption}
                                        checked={
                                          payNowOrLater == "later"
                                            ? true
                                            : false
                                        }
                                      />
                                      <div className="card">
                                        <div className="checked">
                                          <svg
                                            stroke="currentColor"
                                            fill="currentColor"
                                            stroke-width="0"
                                            viewBox="0 0 512 512"
                                            height="1em"
                                            width="1em"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path>
                                          </svg>
                                        </div>
                                        <div className="amount">
                                          <span>
                                            Pay{" "}
                                            {biApiData
                                              ? `₹ ${applyComma(
                                                  Math.round(
                                                    JSON.parse(
                                                      biApiData.BIJson
                                                    )?.[0].MODAL_PREM_DISP
                                                  )
                                                )}`
                                              : "NA"}{" "}
                                            Later!
                                          </span>
                                          <div></div>
                                        </div>
                                        <div className="desc">
                                          <span>
                                            Continue with your application and
                                            pay
                                            {biApiData
                                              ? `₹ ${applyComma(
                                                  Math.round(
                                                    JSON.parse(
                                                      biApiData.BIJson
                                                    )?.[0].MODAL_PREM_DISP
                                                  )
                                                )}`
                                              : "NA"}{" "}
                                            later.
                                          </span>
                                        </div>
                                      </div>
                                    </label>
                                  </div>
                                </RadioContainer>
                              </div>
                            </div>
                          </div>
                      )}
                      {skipPayment && <p style={{
                        textAlign : "center",
                        fontSize : "18px",
                        marginTop : "30px"

                      }}>Premium of Rs {`${biApiData ? applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_DISP)) : "NA"}`} is adjusted against transfer of funds from old application</p>} 
                  </div>
                </div>
              </div>
              <div className="clearfix" />
              <div className="iselect-mg-bottom mt-50 medical-btn hidden-desktop-screen">
                <div className="col-md-12">
                  <div className="but-center text-center">
                  {
                    allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? 
                    (allJourneyData?.proposerDetails?.kycVerified || allJourneyData?.proposerDetails?.ckycVerified || allJourneyData?.proposerDetails?.matchTypeDedupe) &&
                    <div className="submit-btn cen"> <a aria-hidden="true" onClick={handlePrevious}> PREVIOUS </a> </div>
                    :
                      (allJourneyData?.lifeAssuredDetails?.kycVerified || allJourneyData?.lifeAssuredDetails?.ckycVerified || allJourneyData?.lifeAssuredDetails?.matchTypeDedupe) &&
                      <div className="submit-btn cen"> <a aria-hidden="true" onClick={handlePrevious}> PREVIOUS </a> </div>
                    }
                    <input aria-hidden="true" onClick={skipPayment? handleProceedSkipPayment : handleProceed}
                      className="previous-btn cen text-uppercase ls2"
                      style={{
                        color: "white",
                        padding: "14px 40px",
                        border: "none",
                      }}
                      type="button"
                      value="PROCEED"
                    />
                    {allJourneyData?.journeyType === "CanaraPos" &&
                      <span>
                    <input className="previous-btn cen ls2" style={{ color: "white", padding: "14px 40px", border: "none" }} type="submit" value="Send Link to Sales"  onClick={handleSendLinkToSales} />
                    {/* <input className="previous-btn cen ls2" style={{ color: "white", padding: "14px 40px", border: "none" }} type="submit" value="Send Case to Sales"  onClick={handleSendLinkToSales} /> */}
                      </span>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
        {/*left-side*/}
        <div className="iselect-mg-bottom">
          <div className="col-md-12 pl-pr">
            <div className="discloser iselect-box-design">
              <h2>Disclosures:</h2>
              <ul style={{listStyleType:"disc"}}>
                <li>Canara HSBC Life Insurance Invest 4G plan is an Individual / linked/ Limited Pay/Regular Pay/Single Pay/ Life Insurance Plan.</li>
                <li>Tax Benefits under the plan will be as per the prevailing Income Tax laws and are subject to amendments from time to time. For tax related queries, contact your independent tax advisor.</li>
                <li>The above illustration takes into account currently applicable Goods and Services Tax including applicable cess(es)/other levy, if any. However, the applicable taxes may change from time to time and premium payable will change accordingly.</li>
                <li>I have read and understood the product features published by Canara HSBC Life Insurance Company Limited and based on my independent assessment of the features of the product and the risk factors involved therein, I consider this insurance product suitable for my protection need.</li>
                <li>I agree that even if my contact number is registered with NDNC/NCPR, I would still want the Company to contact me on the given number and email ID for the clarifications/ product information sought by me.</li>
              </ul>
              <h2>Notes:</h2>
              <ul style={{listStyleType:"disc"}}>
                <li>Please refer to the product brochure or sample policy contract of this plan on our website www. canarahsbclife.com for detailed product features, conditions and a glossary of terms used.</li>
                <li>Fund management charge is based on the specific fund option(s) chosen.</li>
                <li>In case rider charges are collected explicitly through collection of rider premium, and not by way of cancellation of units, then such charges are not considered in this illustration. In other cases, rider charges are included in other charges.</li>
                <li>*Additions to the fund indicate the Loyalty Additions, Wealth Boosters & Return of Mortality Charge.</li>
                <li>Under 'Care Option', Premium Funding Benefit Charges will be shown in Other Charges.</li>
                <li>The amount payable under the RoMC feature shall exclude any additional charges in respect of mortality that are deducted due to the Life Assured being sub-standard life on grounds of health or is a higher risk for factors other than health such as occupation, etc. The amount payable under the RoMC feature shall exclude Goods and Service Tax and applicable cess(es), if any, that have been deducted with respect to mortality charges. Return of Mortality Charge does not include Premium Funding Benefit Charge, if any. Return of Mortality Charge(RoMC) will not be applicable for Single Premium policies.</li>
                <li>Systematic Withdrawal Option (SWO) is a systematic partial withdrawal facility. Under this option, a pre-decided percentage of the fund value will be withdrawn and paid to the Policyholder at a chosen frequency for the remainder of the Policy starting from the chosen Policy year. The Policyholder can choose SWO at inception or anytime during the Policy Term. For more details regarding SWO, please refer to the product brochure or sample policy contract on the Company's website.</li>
                <li>Under Milestone Withdrawal Option, at the end of the 10th Policy Year and every 5th year thereafter (excluding the milestone coinciding with the Policy Maturity Date), 20% of the available fund value as on the date of payment will be given to the Policyholder. For more details regarding MWO, please refer to the product brochure or sample policy contract on the Company's website.</li>
                <li>Only one of Milestone Withdrawal Option or Systematic Withdrawal Option can be exercised during the Policy Term. Either of the two options can be chosen and changed up to anytime before the payout starts however once the payout from either of the options has started, the Policyholder cannot switch his / her withdrawal option or opt for other withdrawal option. Policyholder can opt out of this option at anytime even after the withdrawals have started but will not be allowed to opt for other withdrawal option available in the Plan.</li>
                <li>Goods and Services Tax under Goods and Services Tax Scheme and other levy(ies), etc by whatever name called have been considered as per the prevailing laws on the date of issuance of this Benefit Illustration on and are subject to change. Liability for bearing Goods and Services Tax including applicable cess(es)/other levy, if any, at the applicable rates on all charges levied under the policy will be on the policyholder.</li>
                <li>Remuneration, if any, to the Insurance Intermediary is not a separate charge on the policy. Remuneration to the Intermediary is 5% of the First Year Premium for Limited / Regular Premium Payment Policies and 2% of Single Premium for Single Premium policies. Remuneration of 0.5% shall be paid from the Second Year till Fifth Year onwards for the sale through Intermediary other than Web Aggregators. No remuneration shall be paid in case of the Online Channel and Direct Channel.</li>
                <li>The benefit illustration is subject to payment of stipulated premiums on due dates. The premium shall be adjusted on the due date even if it has been received in advance.</li>
                <li>At anytime, the Death Benefit will not be less than 105% of all Premiums paid by you up to the date of death. If 'Care Option' is chosen, then in addition to the amount shown in Death Benefit column, future premiums (as and when due), if any, will be paid by the Company.</li>
                <li>Staff includes employees (including their spouse, children and parents) of Canara HSBC Life Insurance Co. Ltd, its shareholder banks (Canara Bank and Punjab National Bank), HSBC Bank and other distribution partners; including their group / associate companies.</li>
                
                <li>
                  Where the fund(s) with the following Segregated Fund Identification Number (SFIN) (Fund Name: Large Cap Advantage Fund & SFIN: ULIF02109/06/20LARCPADFND136) a ached t the Product(s) (Product Name: Canara HSBC Life Insurance Invest 4G & UIN: 136L064V03) approved by the Board of the insurer, which do not comply with Regulation 8 of Schedule I of the IRDAI (Investment) Regulations, 2016 read with the Master Circular  Investment issued thereunder, the Policyholder will be given a free switch to the following funds:
                </li>
                <table class="notesTable">
                      <thead>
                        <tr>
                          <th>S. No.</th>
                          <th>SFIN</th>
                          <th>Fund Name</th>
                          <th>Risk Profile</th>
                        </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td>1</td>
                        <td>ULIF00607/01/10EQUTYIIFND136</td>
                        <td>Equity Fund-II</td>
                        <td>High</td>
                      </tr>
                      <tr>
                        <td>2</td>
                        <td>ULIF01816/08/16IMCAPEQFND136</td>
                        <td>India Multi-Cap Equity Fund</td>
                        <td>High</td>
                      </tr>
                      </tbody>
                </table>
                <li style={{ listStyleType: "none"}}>which have similar fund objective / risk profile with same or lower fund management charge (FMC)$ in compliance with Regula on 8 of Schedule I of the IRDAI (Investment) Regulations, 2016.</li>
                <li style={{ listStyleType: "none"}}><sup>$</sup>Since the proposed fund (Large Cap Advantage Fund) is the lowest FMC equity oriented fund within the fund offerings of Company, the Company shall not be in position to offer the lower FMC. However, the Company shall allow free switch to the above men oned fund with similar risk profile, as per their current applicable FMC which is also part of the Product literature.</li>
              </ul>
              <h2>Disclaimers:</h2>
              <ul style={{listStyleType:"disc"}}>
                <li>Some benefits are guaranteed and some benefits are variable with returns based on the future performance of your Insurer carrying on life insurance business. If your policy offers guaranteed returns then these will be clearly marked "guaranteed" in the illustration table. If your policy offers variable returns then the illustrations will show two different rates of assumed future investment returns. These assumed rates of return are not guaranteed and they are not the upper or lower limits of what you might get back, as the value of your policy is dependent on a number of factors including future investment performance.</li>
                <li>Canara HSBC Life Insurance Company Limited is only the name of the Insurance Company and Canara HSBC Life Insurance Invest 4G is only the name of the unit linked Life Insurance contract and does not in any way indicate the quality of the contract, its future prospects or returns.</li>
                <li>The various funds offered under this contract are the names of the funds and do not in any way indicate the quality of these plans, their future prospects and returns.</li>
                <li>Linked insurance products are different from the traditional insurance products and are subject to the risk factors.</li>
                <li>The premium paid in Linked insurance policies are subject to investment risks associated with capital markets and the NAVs of the units may go up or down based on the performance of fund and factors influencing the capital market and the insured is responsible for his/her decisions.</li>
                <li>Past performance of the investment funds do not indicate the future performance of the same. Investors in the Scheme are not being offered any guaranteed / assured returns.</li>
                <li>You may be entitled for tax benefits under Section 80C and Section 10(10D), as per the Income Tax Act, 1961, as amended from time to time. For tax related queries, please contact your independent tax advisor.</li>
                <li>I have understood the inbuilt features of the policy and the applicable charges. I am fully aware of investment risks under this policy. </li>
              </ul>
              <h6 style={{fontSize:"15px"}}><i>I ALSO UNDERSTAND THAT WHILST 100% OF MY FIRST YEAR PREMIUM WILL BE INVESTED IN UNIT LINKED INVESTMENT FUNDS THERE ARE CHARGES DURING THE FIRST POLICY YEAR AS GIVEN IN THE BENEFIT ILLUSTRATION.</i></h6>
              <p style={{marginTop:"20px"}}>Trade Logo of Canara HSBC Life Insurance Company Limited (formerly known as Canara HSBC Oriental Bank of Commerce Life Insurance Company Ltd) 
              hereinafter referred to as "Insurer" is used under license with Canara Bank and HSBC Group Management Services Limited. The Insurance products
               are offered and underwritten by Insurer <strong>(IRDAI Regn. No. 136)</strong>  having its head office at 139 P, Sector-44, Gurugram 122003, Haryana. For more 
               details on risk factors, terms and conditions please read the sales brochure carefully before concluding a sale. Corporate Identity
                No.: U66010DL2007PLC248825. Website: www.canarahsbclife.com. Call:1800-103-0003/1800-180-0003/1800-891-0003. Give a missed call
                 to: 0124-6156600. SMS: 9779030003. Email: {getSourceFromChannel(journeyState.channel) === "U" ? "onlineterm@canarahsbclife.in" : "customerservice@canarahsbclife.in"}</p>
            </div>
          </div>
        </div>
        {/* <!--mobile view button--> */}
        <div className="mobile-view-btn-Q1 pd-mobile-space-structure button1 canara-pos-bi-btn">
          <div className="iselect-mg-bottom">
            <div className="col-md-12">
              <div className="but-center text-center">
              {
                    allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? 
                    (allJourneyData?.proposerDetails?.kycVerified || allJourneyData?.proposerDetails?.ckycVerified || allJourneyData?.proposerDetails?.matchTypeDedupe) &&
                    <div
                        className="submit-btn cen"
                        style={{ marginRight: "5px" }}
                        >
                        {" "}
                        <a aria-hidden="true" onClick={handlePrevious}>Previous</a>{" "}
                        </div>
                    :
                      (allJourneyData?.lifeAssuredDetails?.kycVerified || allJourneyData?.lifeAssuredDetails?.ckycVerified || allJourneyData?.lifeAssuredDetails?.matchTypeDedupe) &&
                      <div
                          className="submit-btn cen"
                          style={{ marginRight: "5px" }}
                          >
                          {" "}
                          <a aria-hidden="true" onClick={handlePrevious}>Previous</a>{" "}
                          </div>
                    }
                <div className="previous-btn cen">
                  <a>
                    {" "}
                    <button
                      type="submit"
                      value="button1"
                      style={{
                        backgroundColor: "transparent",
                        border: "none",
                        color: "#fff",
                      }}
                      aria-hidden="true"
                      onClick={skipPayment? handleProceedSkipPayment: handleProceed}
                    >
                      Proceed
                    </button>{" "}
                  </a>
                </div>
                  {allJourneyData?.journeyType === "CanaraPos" &&
                <div className="previous-btn cen send-link-to-cust">
                    <span>
                      <input className="previous-btn cen ls2" style={{ color: "white", padding: "14px 40px", border: "none" }} type="submit" value="Send Link to Sales"  onClick={handleSendLinkToSales} />
                    </span>
                </div>
                  }
                {/* <div className="previous-btn cen send-link-to-cust">
                  {allJourneyData?.journeyType === "CanaraPos" &&
                    <span>
                      <input className="previous-btn cen ls2" style={{ color: "white", padding: "14px 40px", border: "none" }} type="submit" value="Send Case to Sales"  onClick={handleSendLinkToSales} />
                    </span>
                  }
                </div> */}
              </div>
            </div>
          </div>
        </div>
        {/* <!--mobile view button-->  */}
        <div className="clearfix"></div>
      </div>)}
    </>
  )
}
